











































































































































































































































































































































































































































































































import Http from "@/mixins/http";
import LocalData from "@/mixins/local-data";
import Toast from "@/mixins/toast";
import { Component, Mixins, Prop } from "vue-property-decorator";
import Card from "../UI/Card.vue";
import moment, { Moment } from 'moment';
import StringViewAndEdit from "@/components/UI/Table/StringViewAndEdit.vue";
import { Modal } from 'ant-design-vue';
import {IdAndName, IParsingConfig, ISelectCompetitorOptionsItem} from "@/interfaces/server-data";
import { SelectOption } from "@/interfaces/global-data";

interface IParserScope {
  formatId: number | null;
  regionId: number | null;
}


interface FilterItem {
  id: number;
  text: string;
  value: number;
  isSelected: boolean;
}

interface TheMarket {
  id: number;
  tradingName: string;
  isDefault: boolean;
  editable: boolean;
}

interface CombinedFilters {
  groups: FilterItem[];
  categories: FilterItem[];
  subcategories: FilterItem[];
  storeFormat: FilterItem[];
  storeRegion: FilterItem[];
  storeCluster: FilterItem[];
}

@Component({
  components: {
    Card,
    StringViewAndEdit,
  },
})
export default class ParsingProducts extends Mixins(LocalData, Toast, Http) {
  @Prop({ required: true }) theFilters!: CombinedFilters;
  @Prop({
    required: true,
    default: { id: 0, tradingName: "", isDefault: false, editable: true },
  })
  theMarket!: TheMarket;

  isShowAddParserModal: boolean = false;
  isUpdateParserConfigModalVisible: boolean = false;
  isCompetitorsSelectDataLoading: boolean = false;
  competitorSelectedData: any = {};
  addParserModalData: any = {
      competitorCode: '',
      competitorName: '',
      competitorWebsiteUrl: null,
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null,
      frequencyValue: null,
      frequencyUnit: "HOURS",
  };

  addParserScope: IParserScope = { formatId: null, regionId: null };
  updateParserScope: IParserScope = { formatId: null, regionId: null };

  selectCompetitorOptions: ISelectCompetitorOptionsItem[] = [];
  competitorDirectoryEntries: ISelectCompetitorOptionsItem[] = [];

  updateParserConfigModalData: any = {
      id: null,
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      frequencyValue: null,
      frequencyUnit: "HOURS",
      inProcess: false,
  };

  pagination = {
      current: 1,
      pageSize: 10,
      total: 0,
  };
  sortingData: any = {
      field: 'id',
      order: 'desc',
  };

  editingUrls: { [x in number]: string | null } = {};

  isParsingConfigsTableLoading: boolean = false;

  parsingSettingsTableOptions: any  = {
      competitorCode: [],
      competitorName: [],
      storeFormat: [],
      storeRegion: [],
  };

  parsingSettingsTableFilterValues: any = {
      competitorCodeList: [],
      competitorNameList: [],
      storeFormatIdList: [],
      storeRegionIdList: [],
  };

  parsingConfigsTableData: IParsingConfig[] = [];

  parsingConfigsTableColumns: any[] = [
    {
      dataIndex: "competitorWebsiteUrl",
      title: this.$t('shared.table.competitorSite') as string,
      width: 300,
      scopedSlots: { customRender: "competitorSite" },
      sorter: true,
    },
    {
      key: "competitorCode",
      dataIndex: "competitorCode",
      title: this.$t('shared.table.competitorCode') as string,
      filterOptionsKey: 'competitorCode',
      filterModelKey: 'competitorCodeList',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      ellipsis: true,
      width: 150,
      sorter: true,
    },
    {
      dataIndex: "competitorName",
      title: this.$t('shared.table.competitorName') as string,
      filterOptionsKey: 'competitorName',
      filterModelKey: 'competitorNameList',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      ellipsis: true,
      width: 190,
      sorter: true,
    },
    {
      dataIndex: "storeFormat.name",
      title: this.$t('shared.table.format') as string,
      width: 110,
      filterOptionsKey: 'storeFormat',
      filterModelKey: 'storeFormatIdList',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      ellipsis: true,
      sorter: true,
    },
    {
      dataIndex: "storeRegion.name",
      title: this.$t('shared.table.region') as string,
      width: 100,
      filterOptionsKey: 'storeRegion',
      filterModelKey: 'storeRegionIdList',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      ellipsis: true,
      sorter: true,
    },
    {
      dataIndex: "competitorsParsingLinkCount",
      title: this.$t('priceMonitoring.parsingSettings.productsCount') as string,
      scopedSlots: { customRender: "productsCount" },
      width: 170,
      ellipsis: true,
    },
    {
      dataIndex: "jobCompletedCount",
      title: this.$t('priceMonitoring.parsingSettings.successCount') as string,
      scopedSlots: { customRender: "successCount" },
      width: 150,
      ellipsis: true,
    },
    {
      dataIndex: "jobErrorCount",
      title: this.$t('priceMonitoring.parsingSettings.failedCount') as string,
      width: 200,
      ellipsis: true,
      scopedSlots: { customRender: "failedCount" },
    },
    {
      dataIndex: "action",
      title: this.$t('shared.table.actions') as string,
      fixed: "right",
      width: 100,
      scopedSlots: { customRender: "action" },
    },
  ];

  mounted() {
      this.fetchParsingConfigs();
      this.fetchParsingConfigsTableOptions();
  }

  handleAddParserClick() {
      this.isShowAddParserModal = true;

     this.fetchCompetitorsDataForSelect();
  }

  handleCloseAddParserModal() {
      this.isShowAddParserModal = false;

      setTimeout(() => {
          this.addParserModalData = {
              competitorCode: '',
              competitorName: '',
              competitorWebsiteUrl: null,
              startDate: null,
              startTime: null,
              endDate: null,
              endTime: null,
              frequencyValue: null,
              frequencyUnit: "HOURS",
          };
          this.addParserScope = { formatId: null, regionId: null };
      }, 500);
  }

  private dedupeByIdAndName(items: IdAndName[]): SelectOption<number | null>[] {
      const seen = new Set<number>();
      const options: SelectOption<number | null>[] = [{ label: this.$t('shared.selectBox.all') as string, value: null }];

      items.forEach((item) => {
          if (item && item.id != null && !seen.has(item.id)) {
              seen.add(item.id);
              options.push({ label: item.name, value: item.id });
          }
      });

      return options;
  }

  get selectedAddParserDirectoryEntries(): ISelectCompetitorOptionsItem[] {
      return this.competitorDirectoryEntries.filter(
          (entry) => entry.competitorCode === this.addParserModalData.competitorCode
      );
  }

  get selectedUpdateParserDirectoryEntries(): ISelectCompetitorOptionsItem[] {
      return this.competitorDirectoryEntries.filter(
          (entry) => entry.competitorCode === this.updateParserConfigModalData.competitorCode
      );
  }

  get addParserFormatOptions(): SelectOption<number | null>[] {
      return this.dedupeByIdAndName(this.selectedAddParserDirectoryEntries.map((entry) => entry.competitorFormat));
  }

  get isAddParserRegionDisabled(): boolean {
      return this.addParserScope.formatId === null;
  }

  get addParserRegionOptions(): SelectOption<number | null>[] {
      const entries = this.selectedAddParserDirectoryEntries.filter(
          (entry) => entry.competitorFormat.id === this.addParserScope.formatId
      );
      return this.dedupeByIdAndName(entries.map((entry) => entry.competitorRegion));
  }

  get updateParserFormatOptions(): SelectOption<number | null>[] {
      return this.dedupeByIdAndName(this.selectedUpdateParserDirectoryEntries.map((entry) => entry.competitorFormat));
  }

  get isUpdateParserRegionDisabled(): boolean {
      return this.updateParserScope.formatId === null;
  }

  get updateParserRegionOptions(): SelectOption<number | null>[] {
      const entries = this.selectedUpdateParserDirectoryEntries.filter(
          (entry) => entry.competitorFormat.id === this.updateParserScope.formatId
      );
      return this.dedupeByIdAndName(entries.map((entry) => entry.competitorRegion));
  }

  get isAddParserPeriodInvalid(): boolean {
      return this.isParsingPeriodInvalid(this.addParserModalData);
  }

  get isUpdateParserPeriodInvalid(): boolean {
      return this.isParsingPeriodInvalid(this.updateParserConfigModalData);
  }

  get isAddParserSaveDisabled(): boolean {
      return !this.addParserModalData.competitorCode
          || !this.momentDateAndTimeToISOString(this.addParserModalData.startDate, this.addParserModalData.startTime)
          || !this.momentDateAndTimeToISOString(this.addParserModalData.endDate, this.addParserModalData.endTime)
          || this.isAddParserPeriodInvalid;
  }

  get isUpdateParserSaveDisabled(): boolean {
      return !this.momentDateAndTimeToISOString(this.updateParserConfigModalData.startDate, this.updateParserConfigModalData.startTime)
          || !this.momentDateAndTimeToISOString(this.updateParserConfigModalData.endDate, this.updateParserConfigModalData.endTime)
          || this.isUpdateParserPeriodInvalid;
  }

  handleAddParserFormatChange(formatId: number | null) {
      this.addParserScope = { formatId, regionId: null };
  }

  handleAddParserRegionChange(regionId: number | null) {
      this.addParserScope = { ...this.addParserScope, regionId };
  }

  handleUpdateParserFormatChange(formatId: number | null) {
      this.updateParserScope = { formatId, regionId: null };
  }

  handleUpdateParserRegionChange(regionId: number | null) {
      this.updateParserScope = { ...this.updateParserScope, regionId };
  }

  private fetchCompetitorsDataForSelect() {
      this.isCompetitorsSelectDataLoading = true;

      this.httpFetchCompetitorsList(this.theMarket.id, {
          current: 1,
          pageSize: 1000,
      }, false)
          .then((response: any) => {
                  const rawData = Array.isArray(response.data)
                      ? response.data
                      : (response.data.content || []);
                  const array: ISelectCompetitorOptionsItem[] = [];

                  rawData.forEach((competitor: any) => {
                      array.push({
                          label: competitor.competitorName,
                          value: `${competitor.competitorCode}-${competitor.competitorFormat.id}-${competitor.competitorRegion.id}`,
                          competitorCode: competitor.competitorCode,
                          competitorName: competitor.competitorName,
                          competitorFormat: competitor.competitorFormat,
                          competitorRegion: competitor.competitorRegion,
                      });
                  });

                  this.competitorDirectoryEntries = [...array];

                  const seenCodes = new Set<string>();
                  this.selectCompetitorOptions = array
                      .filter((item) => {
                          if (seenCodes.has(item.competitorCode)) return false;
                          seenCodes.add(item.competitorCode);
                          return true;
                      })
                      .map((item) => ({ ...item, value: item.competitorCode }));
              },
          ).catch((e) => {
              console.log('ERR', e);
              this.selectCompetitorOptions = [];
              this.competitorDirectoryEntries = [];
          }).finally(() => {
              this.isCompetitorsSelectDataLoading = false;
          });
  }

  handleCompetitorChanged(value: string) {
      const competitor = this.selectCompetitorOptions.find(el => el.value === value)

      if (competitor) {
          this.addParserModalData = {
              ...this.addParserModalData,
              competitorCode: competitor.competitorCode,
              competitorName: competitor.competitorName,
          };
          this.addParserScope = { formatId: null, regionId: null };
      }
  }

  fetchParsingConfigs(currentPage?: number) {
      if (currentPage) {
          this.pagination.current = currentPage;
      }

      this.isParsingConfigsTableLoading = true;

      this.httpFetchParsingConfigs({
          tradingId: this.theMarket.id,
          competitorCodeList: this.parsingSettingsTableFilterValues.competitorCodeList,
          competitorNameList: this.parsingSettingsTableFilterValues.competitorNameList,
          storeFormatIdList: this.parsingSettingsTableFilterValues.storeFormatIdList,
          storeRegionIdList: this.parsingSettingsTableFilterValues.storeRegionIdList,
      }, {
          page: this.pagination.current - 1,
          size: this.pagination.pageSize,
          sortBy: this.sortingData.field,
          sortDirection: this.sortingData.order,
      }).then((response) => {
                  this.parsingConfigsTableData = response.data.content;
                  this.pagination.total = response.data.totalElements;
              },
          ).catch((e) => {
              console.log('ERR', e)
          }).finally(() => {
              this.isParsingConfigsTableLoading = false;
          });
  }

  fetchParsingConfigsTableOptions() {
      this.httpFetchParsingConfigsTableOptions(this.theMarket.id)
          .then((r) => {
                  this.parsingSettingsTableOptions = r.data.fields;
              },
          );
  }

  handleParsingConfigsTableChange(pagination: any, filters: any, sorter: any) {
      this.pagination.current = pagination.current;

      if (sorter.field && sorter.order) {
          this.sortingData = {
              field: sorter.field,
              order: sorter.order === 'descend' ? 'desc' : 'asc',
          }
      } else {
          this.sortingData = {
              field: 'id',
              order: 'desc',
          }
      }

      this.fetchParsingConfigs();
  }

  handleUpdateParserSettings() {
      const parserData: any = {
          tradingId: this.updateParserConfigModalData.tradingId,
          competitorCode: this.updateParserConfigModalData.competitorCode,
          competitorName: this.updateParserConfigModalData.competitorName,
          competitorWebsiteUrl: this.updateParserConfigModalData.competitorWebsiteUrl,
          storeFormatId: this.updateParserScope.formatId,
          storeRegionId: this.updateParserScope.regionId,
          startDateTime: this.momentDateAndTimeToISOString(this.updateParserConfigModalData.startDate, this.updateParserConfigModalData.startTime),
          endDateTime: this.momentDateAndTimeToISOString(this.updateParserConfigModalData.endDate, this.updateParserConfigModalData.endTime),
          frequencyValue: Number(this.updateParserConfigModalData.frequencyValue),
          frequencyUnit: this.updateParserConfigModalData.frequencyUnit,
          inProcess: this.updateParserConfigModalData.inProcess,
      };

      // PUT, а не PATCH: иначе nullable storeFormatId/storeRegionId не сохраняются
      this.httpPutParserSettings(this.updateParserConfigModalData.id, parserData)
          .then(() => {
                  this.fetchParsingConfigs();

                  this.handleCloseUpdateParserConfigModal();
              },
          ).catch((e) => {
          console.log('ERR', e)
      });
  }

  handleToggleParserActivity(item: IParsingConfig) {
      if (!item.startDateTime || !item.endDateTime || !item.frequencyValue ) return;

      this.httpUpdateParserSettings(item.id, { inProcess: !item.inProcess })
          .then(() => {
                  const parser = this.parsingConfigsTableData.find(el => el.id === item.id);

                  if (parser) {
                      parser.inProcess = !item.inProcess;

                      this.showInfo(parser.inProcess
                          ? this.$t('priceMonitoring.parsingSettings.parsingStarted') as string
                          : this.$t('priceMonitoring.parsingSettings.parsingStopped') as string);
                  }
              },
          ).catch((e) => {
              this.showError(!item.inProcess
                  ? this.$t('priceMonitoring.parsingSettings.errorStartParsing') as string
                  : this.$t('priceMonitoring.parsingSettings.errorStopParsing') as string);

              console.log('ERR', e);
      });
  }

  handleSaveParser() {
      const parserData: any = {
          tradingId: this.theMarket.id,
          competitorCode: this.addParserModalData.competitorCode,
          competitorName: this.addParserModalData.competitorName,
          storeFormatId: this.addParserScope.formatId,
          storeRegionId: this.addParserScope.regionId,
          competitorWebsiteUrl: this.addParserModalData.competitorWebsiteUrl,
          startDateTime: this.momentDateAndTimeToISOString(this.addParserModalData.startDate, this.addParserModalData.startTime),
          endDateTime: this.momentDateAndTimeToISOString(this.addParserModalData.endDate, this.addParserModalData.endTime),
          frequencyValue: this.addParserModalData.frequencyValue ? Number(this.addParserModalData.frequencyValue) : null,
          frequencyUnit: this.addParserModalData.frequencyUnit,
          inProcess: false,
      };

      this.httpCreateParser(parserData)
          .then(() => {
                  this.showInfo(this.$t('priceMonitoring.parsingSettings.parserAddedSuccess') as string);

                  this.handleCloseAddParserModal();

                  this.fetchParsingConfigs();
                  this.fetchParsingConfigsTableOptions();
              },
          ).catch((e) => {
              console.log('ERR', e);
          });
  }

  handleOpenUpdateParserConfigModal(item: IParsingConfig) {
      this.updateParserConfigModalData = {
          id: item.id,
          tradingId: item.tradingId,
          competitorCode: item.competitorCode,
          competitorName: item.competitorName,
          competitorWebsiteUrl: item.competitorWebsiteUrl,
          startDate: item.startDateTime,
          startTime: item.startDateTime,
          endDate: item.endDateTime,
          endTime: item.endDateTime,
          frequencyValue: item.frequencyValue,
          frequencyUnit: item.frequencyUnit,
          inProcess: item.inProcess,
      };

      this.updateParserScope = {
          formatId: item.storeFormat ? item.storeFormat.id : null,
          regionId: item.storeRegion ? item.storeRegion.id : null,
      };

      this.fetchCompetitorsDataForSelect();
      this.isUpdateParserConfigModalVisible = true;
  }

  handleCloseUpdateParserConfigModal() {
      this.isUpdateParserConfigModalVisible = false;

      setTimeout(() => {
          this.updateParserConfigModalData = {};
      }, 500);
  }

  handleDeleteParser() {
      Modal.confirm({
          title: this.$t('shared.messages.attention') as string,
          content: this.$t('priceMonitoring.parsingSettings.confirmDeleteContent') as string,
          centered: true,
          okText: this.$t('priceMonitoring.parsingSettings.yesDelete') as string,
          cancelText: this.$t('shared.actions.cancel') as string,
          onOk: () => {
              this.httpDeleteParser(this.updateParserConfigModalData.id).then(() => {
                  this.showInfo(this.$t('priceMonitoring.parsingSettings.parserDeletedSuccess') as string);

                  this.fetchParsingConfigs(1);

                  this.handleCloseUpdateParserConfigModal();
              }).catch(() => {
                  this.showError(this.$t('priceMonitoring.parsingSettings.errorDeleteParser') as string);
              })
          },
      });
  }

  momentDateAndTimeToISOString(dateValue: Moment | string | null, timeValue: Moment | string | null): string | null{
      if (dateValue && timeValue) {
          const date = moment(dateValue);
          const time = moment(timeValue);

          return moment({
              year: date.year(),
              month: date.month(),
              date: date.date(),
              hours: time.hours(),
              minutes: time.minutes(),
              seconds: time.seconds()
          }).utc().toISOString();
      } else if (dateValue) {
          const date = moment(dateValue);

          return date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toISOString();
      } else {
          return null;
      }
  }

  private toMomentDate(value: Moment | string | null): Moment | null {
      if (!value) {
          return null;
      }

      // clone, т.к. вызывающий код делает startOf/endOf('day') — moment мутирует инстанс
      if (moment.isMoment(value)) {
          return value.clone();
      }

      if (typeof value === 'string') {
          const formatted = moment(value, 'DD.MM.YYYY', true);
          if (formatted.isValid()) {
              return formatted;
          }

          const parsed = moment(value);
          return parsed.isValid() ? parsed : null;
      }

      const parsed = moment(value);
      return parsed.isValid() ? parsed : null;
  }

  private isParsingPeriodInvalid(data: any): boolean {
      const startDateTime = this.momentDateAndTimeToISOString(data.startDate, data.startTime);
      const endDateTime = this.momentDateAndTimeToISOString(data.endDate, data.endTime);

      if (!startDateTime || !endDateTime) {
          return false;
      }

      return moment(startDateTime).isAfter(moment(endDateTime));
  }

  disabledDatepickerDate(current: Moment, data: any, property: string) {
      if (current && current < moment().startOf('day')) return true;

      if (property === 'startDate') {
          const endDate = this.toMomentDate(data.endDate);
          if (endDate) {
              return current && current > endDate.endOf('day');
          }
      }

      if (property === 'endDate') {
          const startDate = this.toMomentDate(data.startDate);
          if (startDate) {
              return current && current < startDate.startOf('day');
          }
      }

      return false;
  }

  handleDownloadErrors(id: number) {
      this.httpDownloadParserErrors(id)
          .then(() => {
                  this.showInfo(this.$t('priceMonitoring.parsingSettings.errorsFileCreated') as string);
              },
          ).catch((e) => {
              this.showError(this.$t('priceMonitoring.parsingSettings.errorCreateErrorsFile') as string);
          });
  }

    handleStartLinkEditing(id: number, parsingUrl: string | null) {
        this.editingUrls = {
            ...this.editingUrls,
            [id]: parsingUrl,
        }
    }

    handleCancelLinkEditing(id: number) {
        this.editingUrls[id] = null;
    }

    handleSaveLink(id: number) {
        this.httpUpdateParserSettings(id, { competitorWebsiteUrl: this.editingUrls[id] })
            .then(() => {
                    const parser = this.parsingConfigsTableData.find(el => el.id === id);

                    if (parser) {
                        parser.competitorWebsiteUrl = this.editingUrls[id];
                    }

                    this.showInfo(this.$t('priceMonitoring.parsingSettings.competitorSiteSaved') as string);
                },
            ).catch((e) => {
                this.showError(this.$t('priceMonitoring.parsingSettings.errorSaveCompetitorSite') as string);

                console.log('ERR', e);
            }).finally(() => {
                this.editingUrls[id] = null;
            });
    }

    getCheckboxGroupOptions(filterOptionsKey: keyof any) {
        return (this.parsingSettingsTableOptions[filterOptionsKey] as (string | number)[]).map((el: string | number | IdAndName) => ({
            label: typeof el === 'object' ? el.name : String(el),
            value: typeof el === 'object' ? el.id : el,
        }));
    }
}
